import { render, staticRenderFns } from "./AddOrEditTagModal.vue?vue&type=template&id=d5305b8a&scoped=true&"
import script from "./AddOrEditTagModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditTagModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5305b8a",
  null
  
)

export default component.exports